/** Fallback when API questions are unavailable — keep in sync with backend OnboardingView.QUESTIONS */
export const DEFAULT_ONBOARDING_QUESTIONS = [
  { key: "age", question: "How old are you?", input_type: "number", required: true },
  {
    key: "grade",
    question: "What grade are you in?",
    input_type: "grade_select",
    required: true,
  },
  {
    key: "careers",
    question: "What career(s) are you thinking about?",
    input_type: "text",
    required: false,
  },
  {
    key: "certainty",
    question: "How certain are you about your career path?",
    input_type: "scale_1_10",
    required: true,
  },
  {
    key: "education",
    question: "What is the highest level of education you're aiming for?",
    input_type: "dropdown",
    required: true,
  },
  {
    key: "favorite_ice_cream_flavor",
    question: "Favorite ice cream flavor?",
    input_type: "text",
    required: false,
  },
  {
    key: "terms_block",
    question: "One last thing",
    input_type: "terms_block",
    required: true,
  },
];

export const STEP_UI_BY_KEY = {
  age: {
    emoji: "🎂",
    hint: "You must be 13 or older to use Career Scoops",
  },
  grade: {
    emoji: "🏫",
    hint: "This helps us tailor your experience",
  },
  careers: {
    emoji: "🚀",
    hint: "A career, a field, or a curiosity. Keywords only, separate with commas.",
  },
  certainty: {
    emoji: "🎯",
    hint: "Move the slider to where you are right now",
  },
  education: {
    emoji: "🎓",
    hint: "This helps us match careers to your goals",
  },
  terms_block: {
    emoji: "📋",
    hint: "Review and agree to get started",
  },
  favorite_ice_cream_flavor: {
    emoji: "🍦",
    hint: "This one's just for fun",
  },
};

export const DEFAULT_GRADE_CHOICES = [
  { value: "MD", label: "Middle" },
  { value: "FM", label: "Freshman" },
  { value: "SM", label: "Sophomore" },
  { value: "JR", label: "Junior" },
  { value: "SR", label: "Senior" },
  { value: "GD", label: "Graduated" },
];

export const DEFAULT_EDUCATION_CHOICES = [
  { value: 2, label: "High school diploma or GED" },
  { value: 5, label: "Associate's degree (or other 2-year degree)" },
  { value: 6, label: "Bachelor's degree" },
  { value: 11, label: "Doctoral degree" },
];

export const CERTAINTY_LABELS = [
  "",
  "Not sure at all",
  "Still figuring it out",
  "Getting some ideas",
  "Leaning a few ways",
  "Somewhere in the middle",
  "Feeling more focused",
  "Getting to clarity",
  "Quite confident",
  "Very sure",
  "100% certain",
];
